import React from 'react';
import Header from '../UI/Header/Header';
import classes from './Unknown.module.css';

const Unknown = () => {
  return (
    <>
      <div className={classes.unknown_section}>
        <Header
          header="Answer this to get my number!"
          styles={classes.heading}
        />
        <p className={classes.question}>What is what?</p>
        9834899149
      </div>
    </>
  );
};

export default Unknown;
